import { gql } from "apollo-boost"

export const UPDATE_RISK_MANAGEMENT_FOR_TECHNICAL_MONITORING = gql`
  mutation updateRiskManagementForTechnicalMonitoring($id: String!, $riskData: CreateRiskManagement!) {
    UpdateRiskManagementForTechnicalMonitoring(riskId: $id, riskData: $riskData)
  }
`